export default __webpack_public_path__ + "static/media/face-2.efe2e35c.jpg";